module.exports = __webpack_public_path__ + "img/calendar.30a8eb05.svg";